var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { handleCommaEntered, handleInvalidCharacterAfterZero, isCommaEntered, isFractionTooLong, isInvalidCharacterAfterZero, isMultipleCommas, ONLY_DIGITS_COMMA_OR_DOT_REGEXP, shouldAutoPrefixZero, } from './validationFunctions';
var Input = styled.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: none;\n  width: 100%;\n  flex: 1;\n  font-size: 32px;\n  line-height: 36px;\n  background-color: ", ";\n  color: ", ";\n\n  &:focus-visible {\n    outline: none;\n  }\n"], ["\n  border: none;\n  width: 100%;\n  flex: 1;\n  font-size: 32px;\n  line-height: 36px;\n  background-color: ", ";\n  color: ", ";\n\n  &:focus-visible {\n    outline: none;\n  }\n"])), function (props) { return props.theme.colors.background; }, function (props) {
    return props.error ? props.theme.colors.warning : props.theme.colors.textBodyMain;
});
export var NumberInput = function (_a) {
    var value = _a.value, onChange = _a.onChange, precision = _a.precision, dataTestId = _a.dataTestId;
    var handleInputChange = function (e) {
        var value = e.target.value;
        if (isInvalidCharacterAfterZero(value)) {
            value = handleInvalidCharacterAfterZero(value) || '';
            // block fetch
            if (value === '0') {
                return;
            }
        }
        if (isCommaEntered(value)) {
            value = handleCommaEntered(value);
        }
        if (shouldAutoPrefixZero(value)) {
            value = '0' + value;
        }
        // now we handle the checks during onChange
        if (ONLY_DIGITS_COMMA_OR_DOT_REGEXP.test(value) &&
            !isMultipleCommas(value) &&
            !(precision && isFractionTooLong(value, precision)) &&
            !(value.includes(',') && value.includes('.'))) {
            onChange(value);
        }
    };
    // value validation on insertion
    var onPaste = function (e) {
        e.preventDefault();
        var pasteText = (e.clipboardData ||
            window.clipboardData).getData('text');
        var cleanedText = pasteText.replace(/[^0-9,.]/g, '');
        var finalText = cleanedText;
        // Check if there is a decimal point or comma in the pasted text
        var parts = cleanedText.split(/[,.]/);
        if (parts.length > 1 && precision) {
            var integerPart = parts[0];
            var fractionPart = parts[1];
            if (fractionPart.length > precision) {
                fractionPart = fractionPart.slice(0, precision);
            }
            finalText = "".concat(integerPart, ".").concat(fractionPart);
        }
        document.execCommand('insertText', false, finalText);
    };
    return (_jsx(Input, { onPaste: onPaste, "data-test-id": dataTestId, value: value, type: "text", inputMode: "decimal", onChange: handleInputChange }));
};
var templateObject_1;
